






































import {
    defineComponent,
    inject,
    computed,
    ref,
    onMounted,
} from '@vue/composition-api'
import flatpickr from 'flatpickr'

// Store
import { StoreKey as InputStoreKey } from '@/store/Input'
import { StoreKey as FormStoreKey } from '@/store/Form'
import { StoreKey as ErrorStoreKey } from '@/store/Error'
import { StoreKey as ValidatedStoreKey } from '@/store/Validated'

// Util
import { useValidate } from '@/ts/util/validate'

export default defineComponent({
    setup() {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }
        const inputStore = inject(InputStoreKey)
        if (!inputStore) {
            throw new Error(`${InputStoreKey} is not provided`)
        }
        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }
        const validatedStore = inject(ValidatedStoreKey)
        if (!validatedStore) {
            throw new Error(`${ValidatedStoreKey} is not provided`)
        }

        const validateHandler = useValidate(
            {
                required: ref(true),
            },
            (result, flag) => {
                validatedStore.date = flag

                const messages: string[] = []
                if (result.required === false) {
                    messages.push(formStore.error_message.error_date || '')
                }

                if (messages.length) {
                    errorStore.date.value = [...messages]
                } else {
                    errorStore.date.value = null
                }
            }
        )

        const inputFieldClass = computed(() => {
            return {
                'm-invalid':
                    errorStore.date.value !== null ||
                    validatedStore.date === -1,
                'm-verify': validatedStore.date === 1,
            }
        })

        const dateField = ref<HTMLInputElement>(null)
        const picker = ref<flatpickr.Instance>(null)
        const openDatePickerHandler = () => {
            if (dateField.value && picker.value) {
                picker.value?.open()

                // const rect = dateField.value.getBoundingClientRect()
                // const toTop = rect.top + window.pageYOffset
                // const toTopFixed = toTop.toFixed()

                // // window.scrollTo(0, parseInt(toTopFixed))
                // window.scrollTo({
                //     top: parseInt(toTopFixed),
                //     left: 0,
                //     behavior: 'smooth',
                // })

                // const onScroll = () => {
                //     if (toTopFixed === window.pageYOffset.toFixed()) {
                //         window.removeEventListener('scroll', onScroll)
                //         picker.value?.open()
                //     }
                // }
                // window.addEventListener('scroll', onScroll)
                // onScroll()
            }
        }

        onMounted(() => {
            if (dateField.value) {
                picker.value = flatpickr(dateField.value, {
                    clickOpens: false,
                    dateFormat: 'Y年m月d日',
                    disableMobile: true,
                    disable: [
                        ...formStore.holidays.map((el) => el.day),
                        (date) => {
                            const day = date.getDay() + ''
                            const str = flatpickr.formatDate(date, 'Y-m-d')
                            return (
                                formStore.holiday_week.some(
                                    (el) => el == day
                                ) &&
                                !formStore.workdays.some((el) => el.day == str)
                            )
                        },
                    ],
                    minDate: formStore.calced_date_start,
                    maxDate: formStore.date_end,
                    onReady(_, __, fp) {
                        fp.calendarContainer.classList.add('notranslate')
                    },
                })
            }

            if (inputStore.date) {
                validateHandler(inputStore.date)
            }
        })

        return {
            inputStore,
            errorStore,
            validatedStore,
            inputFieldClass,
            dateField,
            openDatePickerHandler,
            validateHandler,
        }
    },
})
